<template lang="pug">
tl-position(
    class="tl-container"
    x="center"
    y="end"
)
    div(
        :style="containerStyle"
        class="tl-container-content"
    )
        slot
</template>

<script setup>
import { computed, inject } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'

const defaultWidth = 1220

const props = defineProps({
    size: {
        type: [String, Number],
    },
    small: {
        type: Boolean,
    },
    large: {
        type: Boolean,
    },
})
const injects = getInjects(props, inject)

const size = computed(() => parseInt(props.size, 10) ?? parseInt(injects.size, 10) ?? undefined)
const small = computed(() => props.small ?? injects.small ?? false)
const large = computed(() => props.large ?? injects.large ?? false)

const maxWidth = computed(() => {
    if (size.value) return size.value
    if (small.value) return defaultWidth - 260
    if (large.value) return defaultWidth + 420
    return defaultWidth
})

const containerStyle = computed(() => ({
    maxWidth: `${maxWidth.value}px`,
}))
</script>

<style lang="sass" scoped>
.tl-container
    .tl-container-content
        width: 100%
</style>
